
namespace TabAurous.Inventory {
    import fld = StockAllocationItemsBOMRow.Fields;
    @Serenity.Decorators.registerClass()
    export class StockAllocationItemsBOMEditor extends _Ext.BOMGridEditor<StockAllocationItemsBOMRow> { 
        protected getDialogType() { return StockAllocationItemsBOMDialog; }
        protected getLocalTextPrefix() { return StockAllocationItemsBOMRow.localTextPrefix; }
        

        constructor(container: JQuery) {
            super(container); 
            this.slickGrid.setOptions({ rowHeight: 30 }); 

        }  

    }
}